interface FilterPill<T extends string> {
  label: string;
  mode: T;
}

interface FilterPillsProps<T extends string> {
  pills: FilterPill<T>[];
  activeMode: T;
  onChange: (mode: T) => void;
}

export function FilterPills<T extends string>({ pills, activeMode, onChange }: FilterPillsProps<T>) {
  return (
    <div className="flex items-center gap-1.5 ml-1">
      {pills.map((pill) => (
        <button
          key={pill.mode}
          type="button"
          onClick={() => onChange(pill.mode)}
          className={`cursor-pointer rounded-lg border-none px-3 py-1.5 text-2xs font-medium transition-all duration-150 ${
            activeMode === pill.mode
              ? 'bg-brand text-white shadow-sm'
              : 'bg-transparent text-fg-tertiary hover:bg-surface-3 hover:text-fg'
          }`}
        >
          {pill.label}
        </button>
      ))}
    </div>
  );
}
